const errorResponses = {
  errorBoundaryInApp: 'There was an error in the app. Please try again.',
  failedToCleanAndNormalize: 'There was an error cleaning and normalizing. Please try again.',
  failedToDeleteExtraction: 'Sorry, failed to delete extraction.',
  failedToDeleteField: 'Sorry, failed to delete field.',
  failedToImportFields: 'There was an error importing fields. Please try again.',
  failedToLoadDocuments: 'Sorry, failed to load documents.',
  failedToLoadExtraction: 'Sorry, failed to load extraction.',
  failedToLoadExtractionBatch: 'Sorry, failed to load extraction batch.',
  failedToLoadExtractionBatches: 'Sorry, failed to load extraction batches.',
  failedToLoadTrainingSet: 'Sorry, failed to load training set.',
  failedToRenameField: 'There was an error renaming the field.',
  failedToUpdateField: 'There was an error updating the field.',
  failedToSaveGroundTruth: 'There was an error saving the ground truth.',
  failedToDeleteGroundTruth: 'There was an error deleting the ground truth.',
  failedToDataValidation: 'Unable to retrieve validation data',
  validationNotReady:
    'Validation is taking longer than expected. Retry from the field label, the spreadsheet row menu, or the validation errors list.',
  transformationNotFound:
    'Data not available for download. Generate transformed data for all documents prior to downloading',
  failedToSaveCorrection: 'There was an error saving the correction.',
  failedToReTransform: 'There was an error re-extracting. Please try again.',
  failedToGetTransformedData:
    'An error occurred while retrieving transformed data. Please try again or contact your Glynt representative.',
  invalidDataPool: 'Invalid Data Pool. Double check the URL.',
  invalidExtractionBatchId: 'Invalid Extraction Batch. Double check the URL.',
  invalidTrainingListId: 'Invalid Training List. Double check the URL.',
  mismatchedTokenIndex:
    'The original tokens no longer match the current document tokens. Clear and re-mark this field.',
  failedToSetRouterPrefix: 'Failed to set router prefix.',
  failedToDownloadDocument: 'Failed to download document.',
  failedToDownloadPackage: 'Failed to download package.',
  failedToExportDocumentManifest: 'There was an error generating your export.',
  failedToCreateTrainingSet: 'Failed to create training set.',
  failedToCreateExtractionBatch: 'Failed to create extraction batch.',
  failedToReorderField: 'Failed to reorder field.',
  failedToCreateTrainingRevision: 'Failed to create training revision.',
  failedToUpdateTrainingSet: 'Failed to update training set.',
  failedToDeleteTrainingRevision: 'Failed to delete training revision.',
  failedToDeletePackage: 'Failed to delete package.',
  failedToRenameDataPool: 'Failed to rename Data Pool.',
  failedToRenameOrg: 'Failed to rename Organization.',
  failedToCreateOrg: 'Failed to create Organization.',
  failedToUpdateTrainingSetGlobalFormat: 'Failed to update training set global format.',
  failedToCreateDataPool: 'Failed to create Data Pool.',
  failedToUpdateOCR: 'Failed to update OCR Engine',
  failedToLoadOCR: 'Failed to load OCR Engine',
  failedToUpdateFieldRequired: 'Failed to update required property.',
};

export default errorResponses;
